import { v4 } from "uuid";

export const uuidV4 = v4;
